"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Duration = exports.EndOfTurnDuration = exports.TickDuration = exports.TurnDuration = exports.PermanentDuration = exports.InstantDuration = void 0;
const DurationType_1 = require("./enums/DurationType");
class InstantDuration {
    constructor() {
        this.type = DurationType_1.DurationType.Instant;
    }
}
exports.InstantDuration = InstantDuration;
class PermanentDuration {
    constructor() {
        this.type = DurationType_1.DurationType.Permanent;
    }
}
exports.PermanentDuration = PermanentDuration;
class TurnDuration {
    constructor(value) {
        this.value = value;
        this.type = DurationType_1.DurationType.Turns;
    }
}
exports.TurnDuration = TurnDuration;
class TickDuration {
    constructor(value) {
        this.value = value;
        this.type = DurationType_1.DurationType.Ticks;
    }
}
exports.TickDuration = TickDuration;
class EndOfTurnDuration {
    constructor() {
        this.type = DurationType_1.DurationType.EndOfTurn;
    }
}
exports.EndOfTurnDuration = EndOfTurnDuration;
var Duration;
(function (Duration) {
    Duration.Permanent = new PermanentDuration();
    Duration.Turns = (turns) => new TurnDuration(turns);
    Duration.Ticks = (ticks) => new TickDuration(ticks);
    Duration.Instant = new InstantDuration();
    Duration.EndOfTurn = new EndOfTurnDuration();
    function getTurns(duration) {
        switch (duration.type) {
            case DurationType_1.DurationType.EndOfTurn:
                return 0;
            case DurationType_1.DurationType.Ticks:
                return 0;
            case DurationType_1.DurationType.Instant:
                return 0;
            case DurationType_1.DurationType.Permanent:
                return Number.POSITIVE_INFINITY;
            case DurationType_1.DurationType.Turns:
                return duration.value;
            default:
                return 0;
        }
    }
    Duration.getTurns = getTurns;
})(Duration = exports.Duration || (exports.Duration = {}));
